import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import ProtectedRoute from "./ProtectedRoute";

import HomePage from "../pages/home/HomePage";
import SettingsPage from "../pages/settings/SettingsPage";
import LoginPage from "../pages/auth/LoginPage";
import SurveyPage from "../pages/survey/SurveyPage";
import MySurveys from "../pages/my-surveys/MySurveys";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/survey/:surveyType" element={<SurveyPage />} />
            <Route path="/my-surveys" element={<MySurveys />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/home" />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;

